var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "Reason Popup wrapper",
    class: {
      active: _vm.isShow
    }
  }, [_vm.iframeData ? _c('div', {
    staticClass: "Header__detail"
  }, [_c('div', {
    staticClass: "left-btn-group"
  }, [_c('button', {
    on: {
      "click": _vm.goBack
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/svg/arrow-back.svg"),
      "alt": "back"
    }
  })]), _c('h5', [_vm._v(" " + _vm._s(_vm.iframeData.name) + " ")])])]) : _vm._e(), _vm.isShow ? _c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "90%"
    },
    attrs: {
      "id": "iframe",
      "src": _vm.iframeData.link
    }
  }) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }